import angular from 'angular'
import template from './template.html'

angular.module('nominas.cargacontpaq')
  .component('nominasCargacontpaqCalcularItem', {
    template: template,
    controller: NominasCargacontpaqCalcularItemComponent,
    bindings: {
      indice: '<',
      data: '<',
      error: '<',
      pendiente: '<',
      identificador: '<',
      parametros: '<',
      conceptos: '<',
      imssImpuestos: '<',
      scripts: '<',
      onChange: '&',
    },
  });

function NominasCargacontpaqCalcularItemComponent($http) {
  let $ctrl = this;

  $ctrl.$onChanges = $onChanges;
  $ctrl.completado = false;

  function $onChanges(changes) {
    if (changes.pendiente && $ctrl.pendiente) {
      $ctrl.error = null;

      $http.get('/api/nominas/carga-contpaqi/colaboradores/colaborador', {
          params: $ctrl.parametros,
          schema: {
            config: {
              absorber_impuesto_estatal: 'number',
              id_regimen_fiscal: 'number',
              impuesto_estatal_porcentaje: 'number',
              prima_riesgo: 'number',
              salario_diario: 'number',
              salario_diario_integrado: 'number',
            },
          },
        })
        .then(function (response) {
          if (!response.data)
            return $ctrl.error = 'No se encontró al colaborador!';

          $ctrl.colaborador = angular.merge({
            status_calculado: true,
            importe_divisa: null,
            importe: 0,
            comision_porcentaje: 0,
            comision_importe: 0,
            neto: 0,
            total_servicios: 0,
            total_percepciones: 0,
            total_deducciones: 0,
            neto_a_pagar: 0,
            total_prestamos: 0,
            otros: 0,
            percepciones: {},
            deducciones: {},
            incapacidades: [],
            config: {
              carga_social_pendiente: 0,
              cuota_obrera: 0,
              salario_diario: 0,
              salario_diario_real: 0,
              fondo_ahorro_real: 0,
              subsidio: 0,
              impuesto: 0,
              salario_diario_integrado: 0,
              prima_riesgo: 0,
              cobro_carga_social: false,
              pagadora_carga_social: 0,
              pagadora_impuesto_estatal: 0,
              pagadora_isr: 0,
              imss_fondo_retiro_p: 0,
              imss_riesgo_trabajo_p: 0,
              imss_infonavit_p: 0,
              imss_guarderia_p: 0,
              imss_invalidez_p: 0,
              imss_invalidez_t: 0,
              imss_cesantia_p: 0,
              imss_cesantia_t: 0,
              imss_cuota_fija_p: 0,
              imss_cuota_adicional_p: 0,
              imss_cuota_adicional_t: 0,
              imss_prestaciones_p: 0,
              imss_prestaciones_t: 0,
              imss_empresa: 0,
            },
          }, response.data);

          try {
            $ctrl.data = calcular($ctrl.colaborador, {
              uma_importe: 80.04,
            });
          } catch (e) {
            console.error('Error: ' + e);
          }
        })
        .catch(function (response) {
          $ctrl.error = response.data;
        })
        .finally(function () {
          $ctrl.completado = true;

          $ctrl.onChange({
            $event: {
              data: $ctrl.data,
              error: $ctrl.error,
            },
          });
        });
    }
  }

  function calcular(colaborador, config) {
    console.groupCollapsed($ctrl.identificador);
    colaborador = parse(colaborador);

    console.log('calcular', colaborador, config);

    if (!colaborador)
      return null;

    let total_deducciones = 0,
      total_percepciones = 0,
      total = 0,
      percepciones = [],
      deducciones = [],
      idConcepto,
      movimiento;

    calcularSeguroSocial(colaborador, config);
    calcularImpuestoestatal(colaborador);

    if (colaborador.config.carga_social_pendiente) {
      console.info('carga social pendiente', colaborador.config.carga_social_pendiente);
      colaborador.config.carga_social = redondear(colaborador.config.carga_social + colaborador.config.carga_social_pendiente);
    }

    if (colaborador.deducciones[159])// Infonavit
      colaborador.otros = redondear(colaborador.otros + colaborador.deducciones[159].importe);

    if (colaborador.deducciones[161])// Fonacot pendiente
      colaborador.otros = redondear(colaborador.otros + colaborador.deducciones[161].importe);

    if (colaborador.deducciones[152])// Días trabajados
      colaborador.dias_trabajados = colaborador.deducciones[152].dias;

    for (idConcepto in colaborador.percepciones) {
      if (colaborador.percepciones.hasOwnProperty(idConcepto)) {
        movimiento = colaborador.percepciones[idConcepto];

        if (!(movimiento.importe > 0))
          continue;

        movimiento.id_concepto = Number(idConcepto);
        movimiento.id_naturaleza = 'P';
        movimiento.gravado = movimiento.gravado || 0;
        movimiento.exento = movimiento.exento || 0;
        movimiento.horas = movimiento.horas || null;
        movimiento.dias = movimiento.dias || null;
        movimiento.complemento = movimiento.complemento || 0;

        total_percepciones += movimiento.importe;
        total += movimiento.importe;
        percepciones.push(movimiento);
      }
    }

    for (idConcepto in colaborador.deducciones) {
      if (colaborador.deducciones.hasOwnProperty(idConcepto)) {
        movimiento = colaborador.deducciones[idConcepto];

        if (!(movimiento.importe > 0))
          continue;

        movimiento.id_concepto = Number(idConcepto);
        movimiento.id_naturaleza = 'D';
        movimiento.gravado = movimiento.gravado || 0;
        movimiento.exento = movimiento.exento || 0;
        movimiento.horas = movimiento.horas || null;
        movimiento.dias = movimiento.dias || null;
        movimiento.impuesto_estatal = null;
        movimiento.complemento = null;

        total_deducciones += movimiento.importe;
        total -= movimiento.importe;
        deducciones.push(movimiento);
      }
    }

    colaborador.importe = redondear(total_percepciones - total_deducciones);
    colaborador.neto = redondear(total_percepciones - total_deducciones);
    colaborador.total_percepciones = redondear(total_percepciones);
    colaborador.total_deducciones = redondear(total_deducciones);
    colaborador.neto_a_pagar = redondear(total);
    colaborador.percepciones = percepciones;
    colaborador.deducciones = deducciones;

    console.groupEnd();

    return colaborador;
  }

  function calcularImpuestoestatal(colaborador) {
    let porcentaje = colaborador.config.impuesto_estatal_porcentaje,
      faltas_empresa = (colaborador.deducciones[112] && colaborador.deducciones[112].importe) || 0,
      faltas = (colaborador.deducciones[113] && colaborador.deducciones[113].importe) || 0,
      incapacidades = (colaborador.deducciones[114] && colaborador.deducciones[114].importe) || 0,
      conceptos = $ctrl.conceptos.filter(function (concepto) {
        return concepto.naturaleza === 'P';
      }),
      percepciones = conceptos.reduce(function (acumulado, concepto) {
        let percepcion = colaborador.percepciones[concepto.id];

        if (!percepcion)
          return acumulado;

        return acumulado + (concepto.impuesto_estatal ? percepcion.importe : 0);
      }, 0),
      decucciones = faltas_empresa + faltas + incapacidades,
      calcular_impuesto = (percepciones - decucciones) > 0;

    if (!calcular_impuesto)
      console.info('No se cobra impuesto estatal');

    let impuesto_estatal = conceptos.reduce(function (acumulado, concepto) {
      // Si el empleado tiene esta percepción, sumar todos los importes
      let percepcion = colaborador.percepciones[concepto.id],
        importe = 0;

      if (!percepcion)
        return acumulado;

      if (calcular_impuesto) {
        importe = concepto.id === 1
          ? colaborador.percepciones[1].importe - decucciones
          : percepcion.importe;
      }

      percepcion.impuesto_estatal = concepto.impuesto_estatal
        ? redondear(importe * porcentaje, 4)
        : null;

      return redondear(acumulado + (percepcion.impuesto_estatal || 0));
    }, 0);

    console.info('impuesto estatal (%s%)', (porcentaje * 100).toFixed(2), impuesto_estatal);

    if (colaborador.config.id_regimen_fiscal === 2)
      switch (colaborador.config.absorber_impuesto_estatal) {
        case 0:
          colaborador.percepciones[2] = colaborador.percepciones[2] || {};
          colaborador.percepciones[2].importe = redondear(colaborador.percepciones[2].importe - impuesto_estatal);
          colaborador.percepciones[2].exento = redondear(colaborador.percepciones[2].exento - impuesto_estatal);
          colaborador.config.impuesto_estatal = impuesto_estatal;
          break;
        case 1:
          colaborador.config.impuesto_estatal = impuesto_estatal;
          break;
        case 2:
          colaborador.config.impuesto_estatal = 0;
          colaborador.config.pagadora_impuesto_estatal = impuesto_estatal;
          break;
      }
  }

  function calcularSeguroSocial(colaborador, config) {
    let sueldo = (colaborador.percepciones[1] && colaborador.percepciones[1].dias) || 0,
      septimo_dia = (colaborador.percepciones[3] && colaborador.percepciones[3].dias) || 0,
      faltas = (colaborador.deducciones[113] && colaborador.deducciones[113].importe) || 0,
      incapacidades = (colaborador.deducciones[114] && colaborador.deducciones[114].importe) || 0,
      dias_periodo = sueldo + septimo_dia,
      dias_trabajados = Math.max(0, dias_periodo - faltas - incapacidades),
      salario_diario_integrado = colaborador.config.salario_diario_integrado,
      salario_minimo = config.uma_importe;

    let seguro_social_config = {
        prima_riesgo: colaborador.config.prima_riesgo,
        salario_minimo: salario_minimo,
        salario_diario_integrado: salario_diario_integrado,
        dias_periodo: dias_periodo,
        dias_trabajados: dias_trabajados,
        incapacidades: incapacidades,
        faltas: faltas,
      },
      seguro_social = SeguroSocial($ctrl.imssImpuestos, seguro_social_config);

    colaborador.deducciones[152] = {
      importe: seguro_social.cuota_obrera,
      gravado: seguro_social.cuota_obrera,
      exento: 0,
      dias: dias_trabajados,
    };

    colaborador.config.imss_fondo_retiro_p = seguro_social.ramas['fondo_retiro'].p;// fondo_retiro
    colaborador.config.imss_riesgo_trabajo_p = seguro_social.ramas['riesgo_trabajo'].p;// riesgo_trabajo
    colaborador.config.imss_infonavit_p = seguro_social.ramas['infonavit'].p;// infonavit
    colaborador.config.imss_guarderia_p = seguro_social.ramas['guarderia'].p;// guarderia
    colaborador.config.imss_invalidez_p = seguro_social.ramas['invalidez'].p;// i_vida_e
    colaborador.config.imss_invalidez_t = seguro_social.ramas['invalidez'].t;// i_vida_t
    colaborador.config.imss_cesantia_p = seguro_social.ramas['cesantia'].p;// c_vejez_e
    colaborador.config.imss_cesantia_t = seguro_social.ramas['cesantia'].t;// c_vejez_t
    colaborador.config.imss_cuota_fija_p = seguro_social.ramas['cuota_fija'].p;// enf_gral_3_e
    colaborador.config.imss_cuota_adicional_p = seguro_social.ramas['cuota_adicional'].p;// enf_gral_exc_e
    colaborador.config.imss_cuota_adicional_t = seguro_social.ramas['cuota_adicional'].t;// enf_gral_exc_t
    colaborador.config.imss_prestaciones_p = redondear(seguro_social.ramas['prestaciones_1'].p + seguro_social.ramas['prestaciones_2'].p);// enf_gral_din_e
    colaborador.config.imss_prestaciones_t = redondear(seguro_social.ramas['prestaciones_1'].t + seguro_social.ramas['prestaciones_2'].t);// enf_gral_din_t

    colaborador.config.imss_empresa = redondear(0
      + seguro_social.ramas['invalidez'].p
      + seguro_social.ramas['cesantia'].p
      + seguro_social.ramas['cuota_fija'].p
      + seguro_social.ramas['prestaciones_1'].p
      + seguro_social.ramas['prestaciones_2'].p
      + seguro_social.ramas['cuota_adicional'].p,
    );

    colaborador.config.carga_social = seguro_social.carga_social;
    colaborador.config.cuota_obrera = seguro_social.cuota_obrera;
    colaborador.config.cuota_patronal = seguro_social.cuota_patronal;

    console.groupCollapsed('IMSS (152)');
    console.info('incapacidades', incapacidades);
    console.info('carga social', seguro_social.carga_social);
    console.info('cuota obrera', seguro_social.cuota_obrera);
    console.info('cuota patronal', seguro_social.cuota_patronal);
    console.info('dias del período', dias_periodo);
    console.info('dias trabajados', dias_trabajados);
    console.table(seguro_social.ramas);
    console.groupEnd();
  }

  function SeguroSocial(imssImpuestos, conf) {
    let keys = ['cuota_fija', 'prestaciones_1', 'prestaciones_2', 'invalidez', 'cesantia', 'guarderia', 'cuota_adicional', 'riesgo_trabajo', 'fondo_retiro', 'infonavit'],
      ramas = {},
      cuota_obrera = 0,
      cuota_patronal = 0,
      carga_social;

    imssImpuestos.forEach(function (impuesto, index) {
      ramas[keys[index]] = SeguroSocialRama(impuesto, conf);
      cuota_obrera = cuota_obrera + ramas[keys[index]].t;
      cuota_patronal = cuota_patronal + ramas[keys[index]].p;
    });

    carga_social = cuota_obrera + cuota_patronal;

    return {
      carga_social: redondear(carga_social),
      cuota_obrera: redondear(cuota_obrera),
      cuota_patronal: redondear(cuota_patronal),
      ramas: ramas,
    };
  }

  function SeguroSocialRama(impuesto, conf) {
    let salario = Math.min(impuesto.tope_salario_minimo * conf.salario_minimo, conf.salario_diario_integrado),
      rama;

    switch (impuesto.id) {
      case '1': // Prestaciones en Especie Cuota Fija
        rama = {
          p: conf.salario_minimo * (conf.dias_periodo - conf.incapacidades) * impuesto.porcentaje_retencion_patron,
          t: conf.salario_minimo * (conf.dias_periodo - conf.incapacidades) * impuesto.porcentaje_retencion_trabajador,
        };
        break;
      case '2': // Prestaciones en Especie Pensionados y en Dinero
      case '3': // Prestaciones en Especie Pensionados y en Dinero
        rama = {
          p: salario * (conf.dias_periodo - conf.incapacidades) * impuesto.porcentaje_retencion_patron,
          t: salario * (conf.dias_periodo - conf.incapacidades) * impuesto.porcentaje_retencion_trabajador,
        };
        break;
      case '4': // Invalidez y Vida
      case '5': // Cesantia y Vejez
      case '6': // Guarderias
        rama = {
          p: salario * conf.dias_trabajados * impuesto.porcentaje_retencion_patron,
          t: salario * conf.dias_trabajados * impuesto.porcentaje_retencion_trabajador,
        };
        break;
      case '7': // Cuota Adicional Sbc Superior 3 Veces al SMDF
        if (conf.salario_diario_integrado > (conf.salario_minimo * impuesto.tope_salario_minimo)) {
          rama = {
            p: ((conf.salario_minimo * impuesto.tope_salario_minimo) - (conf.salario_minimo * impuesto.tope_cuota_adicional)) * (conf.dias_periodo - conf.incapacidades) * impuesto.porcentaje_retencion_patron,
            t: ((conf.salario_minimo * impuesto.tope_salario_minimo) - (conf.salario_minimo * impuesto.tope_cuota_adicional)) * (conf.dias_periodo - conf.incapacidades) * impuesto.porcentaje_retencion_trabajador,
          };
        } else if (conf.salario_diario_integrado > (conf.salario_minimo * impuesto.tope_cuota_adicional)) {
          rama = {
            p: (conf.salario_diario_integrado - (conf.salario_minimo * impuesto.tope_cuota_adicional)) * (conf.dias_periodo - conf.incapacidades) * impuesto.porcentaje_retencion_patron,
            t: (conf.salario_diario_integrado - (conf.salario_minimo * impuesto.tope_cuota_adicional)) * (conf.dias_periodo - conf.incapacidades) * impuesto.porcentaje_retencion_trabajador,
          };
        } else {
          rama = {
            p: 0,
            t: 0,
          };
        }
        break;
      case '8': // Riesgo de Trabajo
        rama = {
          p: (conf.salario_diario_integrado > (conf.salario_minimo * impuesto.tope_salario_minimo) ? conf.salario_minimo : conf.salario_diario_integrado) * conf.prima_riesgo * conf.dias_trabajados,
          t: 0,
        };
        break;
      case '9': // Calculo de Fondo de retiro
      case '10': // Calculo INFONAVIT
        rama = {
          p: salario * (conf.dias_periodo - conf.faltas) * impuesto.porcentaje_retencion_patron,
          t: salario * (conf.dias_periodo - conf.faltas) * impuesto.porcentaje_retencion_trabajador,
        };
        break;
    }

    return {
      p: redondear(rama.p),
      t: redondear(rama.t),
    };
  }

  function parse(colaborador) {
    let context = {
      colaborador: colaborador,
    };

    context = $ctrl.scripts
      .reduce(function (context, script) {
        return script(context);
      }, context);

    return context && context.colaborador;
  }

  function redondear(value) {
    return parseFloat(value.toFixed(2));
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cargacontpaq/components/calcular/item/component.js